import { defineComponent as T, computed as p, defineAsyncComponent as n, createBlock as I, openBlock as l, resolveDynamicComponent as a } from "vue";
const u = /* @__PURE__ */ T({
  __name: "TnIcon",
  props: {
    name: {},
    color: { default: "currentColor" },
    size: { default: "m" }
  },
  setup(e) {
    const o = e, t = p(() => o.size === "xs" ? "16px" : o.size === "s" ? "20px" : o.size === "m" ? "22px" : o.size === "l" ? "26px" : o.size === "xl" ? "28px" : o.size === "2xl" ? "32px" : "22px"), r = {
      TnIcon0: n(() => import("./TnIcon0-A72qCjp0.js")),
      TnIcon0Filled: n(() => import("./TnIcon0-filled-U9hAryHD.js")),
      TnIcon0Outline: n(() => import("./TnIcon0-outline-BMosSIoQ.js")),
      TnIcon1: n(() => import("./TnIcon1-CdCsQ-dn.js")),
      TnIcon1Filled: n(() => import("./TnIcon1-filled-GU8e3BXo.js")),
      TnIcon1Outline: n(() => import("./TnIcon1-outline-BeRdwh8Y.js")),
      TnIcon2: n(() => import("./TnIcon2-BrmapoEs.js")),
      TnIcon2Filled: n(() => import("./TnIcon2-filled-BrGj6G-l.js")),
      TnIcon2Outline: n(() => import("./TnIcon2-outline-BHr2uew2.js")),
      TnIcon3: n(() => import("./TnIcon3-17p4RPr7.js")),
      TnIcon3Filled: n(() => import("./TnIcon3-filled-Dw92MGbU.js")),
      TnIcon3Outline: n(() => import("./TnIcon3-outline-CteQB5Uq.js")),
      TnIcon4: n(() => import("./TnIcon4-BiAgsduP.js")),
      TnIcon4Filled: n(() => import("./TnIcon4-filled-Bu-RIAdJ.js")),
      TnIcon4Outline: n(() => import("./TnIcon4-outline-wzey2B13.js")),
      TnIcon5: n(() => import("./TnIcon5-DkGXss25.js")),
      TnIcon5Filled: n(() => import("./TnIcon5-filled-DxSg5GIy.js")),
      TnIcon5Outline: n(() => import("./TnIcon5-outline-DuTNkCcB.js")),
      TnIcon6: n(() => import("./TnIcon6-uedgzGFH.js")),
      TnIcon60DayFreeReturns: n(() => import("./TnIcon60-day-free-returns-zN3NQs42.js")),
      TnIcon6Filled: n(() => import("./TnIcon6-filled-6QxnjaZQ.js")),
      TnIcon6Outline: n(() => import("./TnIcon6-outline-CCWHk8_1.js")),
      TnIcon7: n(() => import("./TnIcon7-BjvXz0Xt.js")),
      TnIcon7Filled: n(() => import("./TnIcon7-filled-EpaZC91M.js")),
      TnIcon7Outline: n(() => import("./TnIcon7-outline-BUwW_0TG.js")),
      TnIcon8: n(() => import("./TnIcon8-CDLhCUOD.js")),
      TnIcon8Filled: n(() => import("./TnIcon8-filled-CiG600fD.js")),
      TnIcon8Outline: n(() => import("./TnIcon8-outline-CmBls4AJ.js")),
      TnIcon9: n(() => import("./TnIcon9-gOkmwTPH.js")),
      TnIcon9Filled: n(() => import("./TnIcon9-filled-Cvt91-Wi.js")),
      TnIcon9Outline: n(() => import("./TnIcon9-outline-6HeDDtIB.js")),
      TnIconAccount: n(() => import("./TnIconaccount-DGqjMN7G.js")),
      TnIconAltRoute: n(() => import("./TnIconalt-route-B07OozHR.js")),
      TnIconAntenna: n(() => import("./TnIconantenna-CqLULBO5.js")),
      TnIconAppleAirplay: n(() => import("./TnIconapple-airplay-DicqKnCR.js")),
      TnIconApps: n(() => import("./TnIconapps-eJH5TwIo.js")),
      TnIconAt: n(() => import("./TnIconat-CyVPMqMk.js")),
      TnIconAttentionCircleFilled: n(() => import("./TnIconattention-circle-filled-DoGjOa7G.js")),
      TnIconAttentionCircleOutline: n(() => import("./TnIconattention-circle-outline-zOoKmhOE.js")),
      TnIconBackspace: n(() => import("./TnIconbackspace-hZE6OcGB.js")),
      TnIconBackspaceFilled: n(() => import("./TnIconbackspace-filled-PuTdCwLe.js")),
      TnIconBankID: n(() => import("./TnIconbank-id-jFdV2a3l.js")),
      TnIconBankIDApp: n(() => import("./TnIconbank-id-app-DMs5C5YA.js")),
      TnIconBankIDAppNegative: n(() => import("./TnIconbank-id-app-negative-B0gl95EU.js")),
      TnIconBatteryCharging: n(() => import("./TnIconbattery-charging-BXoLfa26.js")),
      TnIconBatteryEmpty: n(() => import("./TnIconbattery-empty-5OPM4AVR.js")),
      TnIconBatteryFull: n(() => import("./TnIconbattery-full-C_z7KR-V.js")),
      TnIconBatteryHalf: n(() => import("./TnIconbattery-half-C6JUvhzc.js")),
      TnIconBatteryLow: n(() => import("./TnIconbattery-low-BsoFrVIn.js")),
      TnIconBatteryQuarter: n(() => import("./TnIconbattery-quarter-Dkk9xIcK.js")),
      TnIconBills: n(() => import("./TnIconbills-B2291mfX.js")),
      TnIconBookmarkFilled: n(() => import("./TnIconbookmark-filled-Cb_EKy1p.js")),
      TnIconBookmarkOutline: n(() => import("./TnIconbookmark-outline-B70rM9NQ.js")),
      TnIconBookmarks: n(() => import("./TnIconbookmarks-CZpQpLIp.js")),
      TnIconBranch: n(() => import("./TnIconbranch-uImbHzVN.js")),
      TnIconBullet: n(() => import("./TnIconbullet-Drq3RKkc.js")),
      TnIconBulletOutline: n(() => import("./TnIconbullet-outline-BM1646Ma.js")),
      TnIconBullhorn: n(() => import("./TnIconbullhorn-CPxNDXLc.js")),
      TnIconBusiness: n(() => import("./TnIconbusiness-Cmukmoxx.js")),
      TnIconCalendar: n(() => import("./TnIconcalendar-B4VupmFe.js")),
      TnIconCallEnd: n(() => import("./TnIconcall-end-BrHQhV3b.js")),
      TnIconCallForwarded: n(() => import("./TnIconcall-forwarded-C6p2w6Fr.js")),
      TnIconCallForwardedFilled: n(() => import("./TnIconcall-forwarded-filled-DUGSQDi1.js")),
      TnIconCallIncoming: n(() => import("./TnIconcall-incoming-DlNljj3L.js")),
      TnIconCallIncomingFilled: n(() => import("./TnIconcall-incoming-filled-Dtdo3HN8.js")),
      TnIconCallInUse: n(() => import("./TnIconcall-in-use-BkdyBih3.js")),
      TnIconCallInUseFilled: n(() => import("./TnIconcall-in-use-filled-fa8ovUDQ.js")),
      TnIconCallMissed: n(() => import("./TnIconcall-missed-CT4Hm9eG.js")),
      TnIconCallMissedFilled: n(() => import("./TnIconcall-missed-filled-CcGem0Dt.js")),
      TnIconCallOff: n(() => import("./TnIconcall-off-nzPViu01.js")),
      TnIconCallOffFilled: n(() => import("./TnIconcall-off-filled-B5D5ePDd.js")),
      TnIconCallOutgoing: n(() => import("./TnIconcall-outgoing-lt9VJrC5.js")),
      TnIconCallOutgoingFilled: n(() => import("./TnIconcall-outgoing-filled-CC_8fGfx.js")),
      TnIconCallPause: n(() => import("./TnIconcall-pause-oGgWGw6v.js")),
      TnIconCallPauseFilled: n(() => import("./TnIconcall-pause-filled-DZXCf6_G.js")),
      TnIconCamera: n(() => import("./TnIconcamera-DfGyHPX9.js")),
      TnIconCart: n(() => import("./TnIconcart-DJx8h6YS.js")),
      TnIconCartNewItem: n(() => import("./TnIconcart-new-item-BdQjMEiU.js")),
      TnIconCatchUp: n(() => import("./TnIconcatch-up-DgX1FS82.js")),
      TnIconChart: n(() => import("./TnIconchart-BFHG3NnU.js")),
      TnIconCheckboxChecked: n(() => import("./TnIconcheckbox-checked-DDNxQXsK.js")),
      TnIconCheckboxUnchecked: n(() => import("./TnIconcheckbox-unchecked-CHvCRnsC.js")),
      TnIconChevronDown: n(() => import("./TnIconchevron-down-CnBE1c_4.js")),
      TnIconChevronLeft: n(() => import("./TnIconchevron-left-lCwT9Zsi.js")),
      TnIconChevronRight: n(() => import("./TnIconchevron-right-BH2_MetD.js")),
      TnIconChevronsDown: n(() => import("./TnIconchevrons-down-Dy0vwtwm.js")),
      TnIconChevronsLeft: n(() => import("./TnIconchevrons-left-CPbAS3oN.js")),
      TnIconChevronsRight: n(() => import("./TnIconchevrons-right-uNAX9-ZY.js")),
      TnIconChevronsUp: n(() => import("./TnIconchevrons-up-DaxeEVM5.js")),
      TnIconChevronUp: n(() => import("./TnIconchevron-up-CnDAsSW9.js")),
      TnIconChild1: n(() => import("./TnIconchild-1-CiQkrAPe.js")),
      TnIconChild2: n(() => import("./TnIconchild-2-0GAR6w3V.js")),
      TnIconChromecastOff: n(() => import("./TnIconchromecast-off-CVkQmnnf.js")),
      TnIconChromecastOn: n(() => import("./TnIconchromecast-on-BYERGypQ.js")),
      TnIconClock: n(() => import("./TnIconclock-CEoW6GYL.js")),
      TnIconClose: n(() => import("./TnIconclose-J4uucOmw.js")),
      TnIconClosePanelLeft: n(() => import("./TnIconclose-panel-left-B6PJXwkH.js")),
      TnIconClosePanelRight: n(() => import("./TnIconclose-panel-right-4DLxp7Um.js")),
      TnIconCloudDownload: n(() => import("./TnIconcloud-download-Bbe7_OCe.js")),
      TnIconCloudUpload: n(() => import("./TnIconcloud-upload-gf8cWhBP.js")),
      TnIconCode: n(() => import("./TnIconcode-CAGxidgg.js")),
      TnIconCoins: n(() => import("./TnIconcoins-EIF0Fapq.js")),
      TnIconCollapse: n(() => import("./TnIconcollapse-CrNnhPGQ.js")),
      TnIconConnected: n(() => import("./TnIconconnected-Cy4H7KEO.js")),
      TnIconContentSwitcher: n(() => import("./TnIconcontent-switcher-Ci5rtJ81.js")),
      TnIconContractScreen: n(() => import("./TnIconcontract-screen-BdkS5CyB.js")),
      TnIconCookie: n(() => import("./TnIconcookie-Bn2OLX4c.js")),
      TnIconCopy: n(() => import("./TnIconcopy-BbG_iPwZ.js")),
      TnIconCreditCard: n(() => import("./TnIconcredit-card-W7OCFss8.js")),
      TnIconCriticalFilled: n(() => import("./TnIconcritical-filled-B8RhNjaR.js")),
      TnIconCriticalOutline: n(() => import("./TnIconcritical-outline-DaNssvWz.js")),
      TnIconCtaLeft: n(() => import("./TnIconcta-left-BPnE-I_S.js")),
      TnIconCtaRight: n(() => import("./TnIconcta-right-SQGWABQz.js")),
      TnIconCustomerService: n(() => import("./TnIconcustomer-service-B3D5wjQc.js")),
      TnIconDarkMode: n(() => import("./TnIcondark-mode-Cflituai.js")),
      TnIconDarkModeFilled: n(() => import("./TnIcondark-mode-filled-B2POGLP1.js")),
      TnIconDashboard: n(() => import("./TnIcondashboard-X-r-PeR4.js")),
      TnIconDelete: n(() => import("./TnIcondelete-BaECuMal.js")),
      TnIconDeleteFilled: n(() => import("./TnIcondelete-filled-DZ2aPZI7.js")),
      TnIconDelivery: n(() => import("./TnIcondelivery-BesyfWtO.js")),
      TnIconDeliveryExpress: n(() => import("./TnIcondelivery-express-LD7CJajD.js")),
      TnIconDevices: n(() => import("./TnIcondevices-V-tESnUW.js")),
      TnIconDiagonalDownLeft: n(() => import("./TnIcondiagonal-down-left-9Y25c4Wq.js")),
      TnIconDiagonalDownRight: n(() => import("./TnIcondiagonal-down-right-D_fvId4u.js")),
      TnIconDiagonalUpLeft: n(() => import("./TnIcondiagonal-up-left-CvhWJM-X.js")),
      TnIconDiagonalUpRight: n(() => import("./TnIcondiagonal-up-right-BXyuNcti.js")),
      TnIconDiscount: n(() => import("./TnIcondiscount-DvcZl3zL.js")),
      TnIconDocument: n(() => import("./TnIcondocument-Dfz1Y-t5.js")),
      TnIconDocumentAdd: n(() => import("./TnIcondocument-add-BGQp0AS8.js")),
      TnIconDocumentDelete: n(() => import("./TnIcondocument-delete-uUVUbVjk.js")),
      TnIconDocumentDetails: n(() => import("./TnIcondocument-details-CjnbG5-F.js")),
      TnIconDolbyDigital: n(() => import("./TnIcondolby-digital-BYaRl4ht.js")),
      TnIconDown: n(() => import("./TnIcondown-DucYtVNv.js")),
      TnIconDownloadCircle: n(() => import("./TnIcondownload-circle-DBCCxkIG.js")),
      TnIconDownloadCompleteTray: n(() => import("./TnIcondownload-complete-tray-Dj6OW9x4.js")),
      TnIconDownloadProgressCircle: n(() => import("./TnIcondownload-progress-circle-DH3Rhkd2.js")),
      TnIconDownloadToBox: n(() => import("./TnIcondownload-to-box-CMMLJOm5.js")),
      TnIconDownloadTray: n(() => import("./TnIcondownload-tray-981izCuQ.js")),
      TnIconDragDots: n(() => import("./TnIcondrag-dots-Cu9j6Mp2.js")),
      TnIconDragHandleHorisontal: n(() => import("./TnIcondrag-handle-horisontal-DFwMxlcc.js")),
      TnIconDragHandleVertical: n(() => import("./TnIcondrag-handle-vertical-tNJT63UO.js")),
      TnIconEdit: n(() => import("./TnIconedit-CkVAmV-4.js")),
      TnIconEmail: n(() => import("./TnIconemail-EMFO9fvy.js")),
      TnIconEmployee: n(() => import("./TnIconemployee-Bxv1bmBh.js")),
      TnIconErrorCircleFilled: n(() => import("./TnIconerror-circle-filled-CgwOLPLp.js")),
      TnIconErrorCircleOutline: n(() => import("./TnIconerror-circle-outline-9QNi6-FO.js")),
      TnIconeSim: n(() => import("./TnIcone-sim-yfn_vymG.js")),
      TnIconEthernet: n(() => import("./TnIconethernet-Ceh85kYO.js")),
      TnIconExpand: n(() => import("./TnIconexpand-CFd_AkIB.js")),
      TnIconExpandInputBox: n(() => import("./TnIconexpand-input-box-DSh_EF6L.js")),
      TnIconExpandScreen: n(() => import("./TnIconexpand-screen-jAMZGYIz.js")),
      TnIconExpressDelivery: n(() => import("./TnIconexpress-delivery-gYA4H923.js")),
      TnIconExternalLink: n(() => import("./TnIconexternal-link-kGVTpz8g.js")),
      TnIconEyeClosed: n(() => import("./TnIconeye-closed-Dnp4M9jl.js")),
      TnIconEyeOff: n(() => import("./TnIconeye-off-DPPVofLz.js")),
      TnIconEyeOpen: n(() => import("./TnIconeye-open-jWRdyptr.js")),
      TnIconFacebook: n(() => import("./TnIconfacebook-BJ48TCJs.js")),
      TnIconFaceID: n(() => import("./TnIconface-id-CprjR8HS.js")),
      TnIconFamily: n(() => import("./TnIconfamily-DyYouSBb.js")),
      TnIconFiber: n(() => import("./TnIconfiber-DRkQVbtc.js")),
      TnIconFigma: n(() => import("./TnIconfigma-oDNa6ep4.js")),
      TnIconFigmaOutline: n(() => import("./TnIconfigma-outline-DRjuLWit.js")),
      TnIconFilter: n(() => import("./TnIconfilter-4DE5mffC.js")),
      TnIconFingerprint: n(() => import("./TnIconfingerprint-BDCImbre.js")),
      TnIconFlagFilled: n(() => import("./TnIconflag-filled-BHgP7_Wk.js")),
      TnIconFlagOutline: n(() => import("./TnIconflag-outline-BB9oUMez.js")),
      TnIconFloppy: n(() => import("./TnIconfloppy-C9ZrJo5n.js")),
      TnIconFolder: n(() => import("./TnIconfolder-617OuMqJ.js")),
      TnIconFolderAdd: n(() => import("./TnIconfolder-add-BvGsbhRZ.js")),
      TnIconFolders: n(() => import("./TnIconfolders-7dflqlk_.js")),
      TnIconFreeDeliveryAndReturns: n(() => import("./TnIconfree-delivery-and-returns-BOqlWscz.js")),
      TnIconFullScreen: n(() => import("./TnIconfull-screen-w1HM2WYb.js")),
      TnIconGenre: n(() => import("./TnIcongenre-DLffclyz.js")),
      TnIconGift: n(() => import("./TnIcongift-C13iLxqC.js")),
      TnIconGithub: n(() => import("./TnIcongithub-Ct6wqum3.js")),
      TnIconGlobe: n(() => import("./TnIconglobe-DGujWN_O.js")),
      TnIconGraph: n(() => import("./TnIcongraph-BRm24lul.js")),
      TnIconHardOfHearing: n(() => import("./TnIconhard-of-hearing-HkxSf4gK.js")),
      TnIconHeartFilled: n(() => import("./TnIconheart-filled-DiBFGLzv.js")),
      TnIconHeartOutline: n(() => import("./TnIconheart-outline-BDikhm0g.js")),
      TnIconHelp: n(() => import("./TnIconhelp-DH90TjdK.js")),
      TnIconHistory: n(() => import("./TnIconhistory-CTtITe1h.js")),
      TnIconHome: n(() => import("./TnIconhome-DrBIv8L1.js")),
      TnIconHourglass: n(() => import("./TnIconhourglass-hPMSjfWu.js")),
      TnIconHourglassFinished: n(() => import("./TnIconhourglass-finished-DNOXq-On.js")),
      TnIconHourglassRunning: n(() => import("./TnIconhourglass-running-B80xU3mo.js")),
      TnIconInfinity: n(() => import("./TnIconinfinity-BbCMp2Ol.js")),
      TnIconInfoCircleFilled: n(() => import("./TnIconinfo-circle-filled-BnguBxB5.js")),
      TnIconInfoCircleOutline: n(() => import("./TnIconinfo-circle-outline-CTFBm9Bm.js")),
      TnIconInfoStandalone: n(() => import("./TnIconinfo-standalone-Dg0BGIfe.js")),
      TnIconInstagram: n(() => import("./TnIconinstagram-Bbaf9CbL.js")),
      TnIconInvoice: n(() => import("./TnIconinvoice-Ct-crk94.js")),
      TnIconInvoiceAccount: n(() => import("./TnIconinvoice-account-BTfVEqfi.js")),
      TnIconIoTSim: n(() => import("./TnIconio-t-sim-DzMdjzJV.js")),
      TnIconKey: n(() => import("./TnIconkey-DmXmVR-k.js")),
      TnIconKeypad: n(() => import("./TnIconkeypad-DO3a5G06.js")),
      TnIconKroner: n(() => import("./TnIconkroner-BLgIEW07.js")),
      TnIconLan: n(() => import("./TnIconlan-afdlAFaX.js")),
      TnIconLaptop: n(() => import("./TnIconlaptop-Da7NjJgm.js")),
      TnIconLeft: n(() => import("./TnIconleft-CDKjodYF.js")),
      TnIconLightbulb: n(() => import("./TnIconlightbulb-Bbmop1yO.js")),
      TnIconLightMode: n(() => import("./TnIconlight-mode-l4dh6qDF.js")),
      TnIconLightModeFilled: n(() => import("./TnIconlight-mode-filled-LfnFpyLE.js")),
      TnIconLightningFilled: n(() => import("./TnIconlightning-filled-DzgqxO4L.js")),
      TnIconLightningFilledwithOutline: n(() => import("./TnIconlightning-filled-with-outline-BvuoJ2WN.js")),
      TnIconLightningOutline: n(() => import("./TnIconlightning-outline-C2s5ehFt.js")),
      TnIconLink: n(() => import("./TnIconlink-Br0TcOk9.js")),
      TnIconLink2: n(() => import("./TnIconlink-2-DqTLrcJD.js")),
      TnIconLinkedIn: n(() => import("./TnIconlinked-in-Dv13NcYr.js")),
      TnIconLive: n(() => import("./TnIconlive-z_DuJA06.js")),
      TnIconLocation: n(() => import("./TnIconlocation-CPNlai_3.js")),
      TnIconLocationFilled: n(() => import("./TnIconlocation-filled-ChCGa5BS.js")),
      TnIconLocationFilledwithOutline: n(() => import("./TnIconlocation-filled-with-outline-vq1vtzXM.js")),
      TnIconLockFilledClosed: n(() => import("./TnIconlock-filled-closed-iRN3r10T.js")),
      TnIconLockFilledOpen: n(() => import("./TnIconlock-filled-open-YoMDUbHn.js")),
      TnIconLockOutlineClosed: n(() => import("./TnIconlock-outline-closed-BBeMaEw5.js")),
      TnIconLockOutlineOpen: n(() => import("./TnIconlock-outline-open-B3GObtRN.js")),
      TnIconLog: n(() => import("./TnIconlog-PlBz6-wI.js")),
      TnIconLogIn: n(() => import("./TnIconlog-in-DC4wY3OQ.js")),
      TnIconLogOut: n(() => import("./TnIconlog-out-BsD3mlO8.js")),
      TnIconLongDown: n(() => import("./TnIconlong-down-BB4JbfgB.js")),
      TnIconLongLeft: n(() => import("./TnIconlong-left-BNqKE8CR.js")),
      TnIconLongRight: n(() => import("./TnIconlong-right-BXg6DLFG.js")),
      TnIconLongUp: n(() => import("./TnIconlong-up-C4dIKgLi.js")),
      TnIconMaximise: n(() => import("./TnIconmaximise-BqgKwzhU.js")),
      TnIconMegaphone: n(() => import("./TnIconmegaphone-BSouV5dp.js")),
      TnIconMenu: n(() => import("./TnIconmenu-xePh0pwR.js")),
      TnIconMessage: n(() => import("./TnIconmessage-BRPZjAGE.js")),
      TnIconMicrophoneOff: n(() => import("./TnIconmicrophone-off-DxlEjUZZ.js")),
      TnIconMicrophoneOn: n(() => import("./TnIconmicrophone-on-B0cSLD1X.js")),
      TnIconMicrosoftOffice: n(() => import("./TnIconmicrosoft-office-DIcdmNoT.js")),
      TnIconMinimise: n(() => import("./TnIconminimise-duOBqvG6.js")),
      TnIconMinus: n(() => import("./TnIconminus-CP2UAeWE.js")),
      TnIconMinusCircleFilled: n(() => import("./TnIconminus-circle-filled-C4cRs6Mo.js")),
      TnIconMinusCircleOutline: n(() => import("./TnIconminus-circle-outline-OrCjd0_G.js")),
      TnIconMonitor: n(() => import("./TnIconmonitor-CJe0IyhP.js")),
      TnIconMovieArchive: n(() => import("./TnIconmovie-archive-DyRgpnCO.js")),
      TnIconMovieClip: n(() => import("./TnIconmovie-clip-dewYmsKm.js")),
      TnIconMovies: n(() => import("./TnIconmovies-aQAR2fLo.js")),
      TnIconMusic: n(() => import("./TnIconmusic-BuThZwtC.js")),
      TnIconNearMeOff: n(() => import("./TnIconnear-me-off-eKNfDJb3.js")),
      TnIconNearMeOn: n(() => import("./TnIconnear-me-on-KZwcz2h0.js")),
      TnIconNoBinding: n(() => import("./TnIconno-binding-DWGEzN2a.js")),
      TnIconNotificationFilled: n(() => import("./TnIconnotification-filled-Bf56B_ms.js")),
      TnIconNotificationNew: n(() => import("./TnIconnotification-new-DGZLvfds.js")),
      TnIconNotificationNone: n(() => import("./TnIconnotification-none-BeHiIBNo.js")),
      TnIconOpeninnewWindow: n(() => import("./TnIconopen-in-new-window-Ce29wEV_.js")),
      TnIconOpenPanelLeft: n(() => import("./TnIconopen-panel-left-i-tJoksl.js")),
      TnIconOpenPanelRight: n(() => import("./TnIconopen-panel-right-CnJS2OMf.js")),
      TnIconOverflowMenuHorizontal: n(() => import("./TnIconoverflow-menu-horizontal-shpoWMQm.js")),
      TnIconOverflowMenuVertical: n(() => import("./TnIconoverflow-menu-vertical-CT5-H4H4.js")),
      TnIconPaperclip: n(() => import("./TnIconpaperclip-C09p1-We.js")),
      TnIconPaste: n(() => import("./TnIconpaste-D4EjHkND.js")),
      TnIconPause: n(() => import("./TnIconpause-BNDg2t-n.js")),
      TnIconPauseCircleOutline: n(() => import("./TnIconpause-circle-outline-DHqlFSlT.js")),
      TnIconPauseLarge: n(() => import("./TnIconpause-large-DvPRRRf6.js")),
      TnIconPendingCircleFilled: n(() => import("./TnIconpending-circle-filled-CF0sBR-1.js")),
      TnIconPendingCircleOutline: n(() => import("./TnIconpending-circle-outline-Du3krtOX.js")),
      TnIconPeople: n(() => import("./TnIconpeople-Dc9uyF8w.js")),
      TnIconPerson: n(() => import("./TnIconperson-DPiM5PeO.js")),
      TnIconPhoneLandline: n(() => import("./TnIconphone-landline-ql6GikTJ.js")),
      TnIconPhoneMobile: n(() => import("./TnIconphone-mobile-BkFEUBuY.js")),
      TnIconPhoneReceiver: n(() => import("./TnIconphone-receiver-fILkHeZV.js")),
      TnIconPhoneReceiverFilled: n(() => import("./TnIconphone-receiver-filled-DoP39Kyc.js")),
      TnIconPickUp: n(() => import("./TnIconpick-up-CN-m9yiM.js")),
      TnIconPictureInPictureIn: n(() => import("./TnIconpicture-in-picture-in-DX2s9S6Q.js")),
      TnIconPictureinPictureOut: n(() => import("./TnIconpicture-in-picture-out-B467idfO.js")),
      TnIconPieChart: n(() => import("./TnIconpie-chart-DBHf3b4R.js")),
      TnIconPlay: n(() => import("./TnIconplay-D86Y2Oeq.js")),
      TnIconPlayCircleOutline: n(() => import("./TnIconplay-circle-outline-Cvc77KNI.js")),
      TnIconPlayFilled: n(() => import("./TnIconplay-filled-BRWMZMWz.js")),
      TnIconPlayLarge: n(() => import("./TnIconplay-large-BCANTRys.js")),
      TnIconPlayOnBox: n(() => import("./TnIconplay-on-box-BcH4VaUl.js")),
      TnIconPlayOnFetch: n(() => import("./TnIconplay-on-fetch-DXkRnxRy.js")),
      TnIconPlus: n(() => import("./TnIconplus-BBrARvfi.js")),
      TnIconPlusCircleFilled: n(() => import("./TnIconplus-circle-filled-DlzK9qH1.js")),
      TnIconPlusCircleOutline: n(() => import("./TnIconplus-circle-outline-o6lRYtOA.js")),
      TnIconPrinter: n(() => import("./TnIconprinter-Do5Q4ITS.js")),
      TnIconPushPinFilled: n(() => import("./TnIconpush-pin-filled-JeqE6JWS.js")),
      TnIconPushPinOutline: n(() => import("./TnIconpush-pin-outline-CmD1vKtw.js")),
      TnIconQr: n(() => import("./TnIconqr-BgE6H-1H.js")),
      TnIconQuestion: n(() => import("./TnIconquestion-DI27xtBB.js")),
      TnIconQuestionCircleFilled: n(() => import("./TnIconquestion-circle-filled-CAy1UJJE.js")),
      TnIconQuestionCircleOutline: n(() => import("./TnIconquestion-circle-outline-CxL1ciXc.js")),
      TnIconQueue: n(() => import("./TnIconqueue-jFuC03lj.js")),
      TnIconRadio: n(() => import("./TnIconradio-BQs01JGv.js")),
      TnIconRadioButtonChecked: n(() => import("./TnIconradio-button-checked-C-fLzcsH.js")),
      TnIconRadioButtonUnchecked: n(() => import("./TnIconradio-button-unchecked-SyYNr6d1.js")),
      TnIconRec: n(() => import("./TnIconrec-D6ZJOzUF.js")),
      TnIconReceipt: n(() => import("./TnIconreceipt-Bzb67RFw.js")),
      TnIconRecycle: n(() => import("./TnIconrecycle-Dti1-i5r.js")),
      TnIconRedo: n(() => import("./TnIconredo-CVVQy1ln.js")),
      TnIconRefresh: n(() => import("./TnIconrefresh-YwhaMVLk.js")),
      TnIconReload: n(() => import("./TnIconreload-BA2F5blE.js")),
      TnIconRemove: n(() => import("./TnIconremove-IbxBjILQ.js")),
      TnIconRemoveCircleFilled: n(() => import("./TnIconremove-circle-filled-VtfE78S5.js")),
      TnIconRemoveCircleOutline: n(() => import("./TnIconremove-circle-outline-JYeJnOBH.js")),
      TnIconResumeWatching: n(() => import("./TnIconresume-watching-CwolxE73.js")),
      TnIconRight: n(() => import("./TnIconright-SQurE8VN.js")),
      TnIconRouter: n(() => import("./TnIconrouter-Dc1R3ogf.js")),
      TnIconRouting: n(() => import("./TnIconrouting-DRJBrEB6.js")),
      TnIconSearch: n(() => import("./TnIconsearch-BDpGiz8W.js")),
      TnIconSecurity: n(() => import("./TnIconsecurity-BKtGCffj.js")),
      TnIconSecurityAlert: n(() => import("./TnIconsecurity-alert-B-k3_vP4.js")),
      TnIconSecurityOff: n(() => import("./TnIconsecurity-off-yP23IOi6.js")),
      TnIconSecurityOn: n(() => import("./TnIconsecurity-on-BYmrpDWD.js")),
      TnIconSend: n(() => import("./TnIconsend-wYC9P-eL.js")),
      TnIconSeries: n(() => import("./TnIconseries-DxlDhkVy.js")),
      TnIconSeriesArchive: n(() => import("./TnIconseries-archive-Bbr-KHyF.js")),
      TnIconService: n(() => import("./TnIconservice-j5YtG_NA.js")),
      TnIconServices: n(() => import("./TnIconservices-ontzg8YB.js")),
      TnIconSettings: n(() => import("./TnIconsettings-CY8UqExN.js")),
      TnIconSettingsComplex: n(() => import("./TnIconsettings-complex-C4D18saP.js")),
      TnIconShare: n(() => import("./TnIconshare-5l9K8pOA.js")),
      TnIconShareContent: n(() => import("./TnIconshare-content-wn4kKkg-.js")),
      TnIconSim: n(() => import("./TnIconsim-DmozY3J3.js")),
      TnIconSkipBack10s: n(() => import("./TnIconskip-back-10s-NntZXZt4.js")),
      TnIconSkipBackward15s: n(() => import("./TnIconskip-backward-15s-OCw63fSj.js")),
      TnIconSkipBackward30s: n(() => import("./TnIconskip-backward-30s-BsaATV6C.js")),
      TnIconSkipForward: n(() => import("./TnIconskip-forward-DoGTn5_U.js")),
      TnIconSkipForward10s: n(() => import("./TnIconskip-forward-10s-BLearTp_.js")),
      TnIconSkipForward15s: n(() => import("./TnIconskip-forward-15s-l-lyOBs_.js")),
      TnIconSkipForward30s: n(() => import("./TnIconskip-forward-30s-yZIhKzve.js")),
      TnIconSkiptoNext: n(() => import("./TnIconskip-to-next-BPZ8Q4b0.js")),
      TnIconSkiptoPrevious: n(() => import("./TnIconskip-to-previous-SprfVas9.js")),
      TnIconSlack: n(() => import("./TnIconslack-DNdnspxZ.js")),
      TnIconSlackNegative: n(() => import("./TnIconslack-negative-CeOaBQdE.js")),
      TnIconSms: n(() => import("./TnIconsms-uN70BHae.js")),
      TnIconSoftphoneConnected: n(() => import("./TnIconsoftphone-connected-BI7jHYRw.js")),
      TnIconSoftphoneDisconnected: n(() => import("./TnIconsoftphone-disconnected-DYGrLm8G.js")),
      TnIconSort: n(() => import("./TnIconsort-DpjtSyxL.js")),
      TnIconSortDown: n(() => import("./TnIconsort-down-C6Pggs-w.js")),
      TnIconSortFilled: n(() => import("./TnIconsort-filled-B5RB1fKY.js")),
      TnIconSortHorizontal: n(() => import("./TnIconsort-horizontal-CdjL4wqi.js")),
      TnIconSortOutline: n(() => import("./TnIconsort-outline-D1smrF1c.js")),
      TnIconSortUp: n(() => import("./TnIconsort-up-C6-Eadgz.js")),
      TnIconSoundWave: n(() => import("./TnIconsound-wave-idanWrMZ.js")),
      TnIconSpaceBar: n(() => import("./TnIconspace-bar-B6WWFJe3.js")),
      TnIconSpeakerOff: n(() => import("./TnIconspeaker-off-ByAfa_4C.js")),
      TnIconSpeakerOn: n(() => import("./TnIconspeaker-on-DqGzriDn.js")),
      TnIconSpeed: n(() => import("./TnIconspeed-BFsQHroF.js")),
      TnIconSpinner: n(() => import("./TnIconspinner-ZInFhjym.js")),
      TnIconSplit: n(() => import("./TnIconsplit-CBPM-d2j.js")),
      TnIconSport: n(() => import("./TnIconsport-DHzEhwIh.js")),
      TnIconStarFilled: n(() => import("./TnIconstar-filled-CtA_OUVY.js")),
      TnIconStarOutline: n(() => import("./TnIconstar-outline-CEjn62dw.js")),
      TnIconStartOver: n(() => import("./TnIconstart-over-BSYGOw19.js")),
      TnIconStop: n(() => import("./TnIconstop-CNtrGbY7.js")),
      TnIconStorage: n(() => import("./TnIconstorage-sZHrmI8K.js")),
      TnIconStorybook: n(() => import("./TnIconstorybook-9hbKlH03.js")),
      TnIconStorybookNegative: n(() => import("./TnIconstorybook-negative-D3QcZdKK.js")),
      TnIconSubdirectoryLeft: n(() => import("./TnIconsubdirectory-left-CcjpRt1s.js")),
      TnIconSubdirectoryRight: n(() => import("./TnIconsubdirectory-right-BziNuMLf.js")),
      TnIconSubscription: n(() => import("./TnIconsubscription-BI8TVcgK.js")),
      TnIconSubtitles: n(() => import("./TnIconsubtitles-D5E6A0cw.js")),
      TnIconSuccess: n(() => import("./TnIconsuccess-C-tGQDSf.js")),
      TnIconSuccessCircleFilled: n(() => import("./TnIconsuccess-circle-filled-CLac-Soy.js")),
      TnIconSuccessCircleOutline: n(() => import("./TnIconsuccess-circle-outline-wlvPvVG0.js")),
      TnIconTableofContent: n(() => import("./TnIcontable-of-content-DuvhVCKR.js")),
      TnIconTag: n(() => import("./TnIcontag-BAIiEWUM.js")),
      TnIconTagFilled: n(() => import("./TnIcontag-filled-Bii0ZC0S.js")),
      TnIconTelegrafen: n(() => import("./TnIcontelegrafen-CwgaAZzy.js")),
      TnIconTelegrafen1px: n(() => import("./TnIcontelegrafen-1px-4NMpYWfV.js")),
      TnIconTelenor: n(() => import("./TnIcontelenor-CDEoN_SG.js")),
      TnIconTelenorNegative: n(() => import("./TnIcontelenor-negative-BHFdGvGL.js")),
      TnIconThumbsDownFilled: n(() => import("./TnIconthumbs-down-filled-DpE7BMfX.js")),
      TnIconThumbsDownOutline: n(() => import("./TnIconthumbs-down-outline-D7NTabfJ.js")),
      TnIconThumbsUpFilled: n(() => import("./TnIconthumbs-up-filled-B_2svCyd.js")),
      TnIconThumbsUpOutline: n(() => import("./TnIconthumbs-up-outline-15PqmzbD.js")),
      TnIconTickets: n(() => import("./TnIcontickets-CuBIzAa_.js")),
      TnIconTimer: n(() => import("./TnIcontimer-22bIPDa3.js")),
      TnIconTrashcan: n(() => import("./TnIcontrashcan-6lFgz4ld.js")),
      TnIconTrashcanOpen: n(() => import("./TnIcontrashcan-open-CbceSpWV.js")),
      TnIconTrendingDown: n(() => import("./TnIcontrending-down-CTyXoHjq.js")),
      TnIconTrendingStable: n(() => import("./TnIcontrending-stable-CrhANlTs.js")),
      TnIconTrendingUp: n(() => import("./TnIcontrending-up-CUtMAdi9.js")),
      TnIconTv: n(() => import("./TnIcontv-BZdkaHg5.js")),
      TnIconTvArchive: n(() => import("./TnIcontv-archive-WgsK32n0.js")),
      TnIconTvGuide: n(() => import("./TnIcontv-guide-C_A57HrY.js")),
      TnIconTWeBox: n(() => import("./TnIcont-we-box-DyuZmeXY.js")),
      TnIconTwitterLegacy: n(() => import("./TnIcontwitter-legacy-ewsNvgBC.js")),
      TnIconUnavailable: n(() => import("./TnIconunavailable-Cx_QYvaX.js")),
      TnIconUndo: n(() => import("./TnIconundo-BLKmynCB.js")),
      TnIconUp: n(() => import("./TnIconup-2-nUvnpf.js")),
      TnIconUploadTray: n(() => import("./TnIconupload-tray-BKyjaPTZ.js")),
      TnIconVideocameraOn: n(() => import("./TnIconvideocamera-on-BY6d5TOk.js")),
      TnIconVideoOnDemand: n(() => import("./TnIconvideo-on-demand-Dbd5ByZQ.js")),
      TnIconViewCard: n(() => import("./TnIconview-card-BIhfK9Th.js")),
      TnIconViewHorizontalCard: n(() => import("./TnIconview-horizontal-card-DGlO17Cv.js")),
      TnIconViewList: n(() => import("./TnIconview-list-9p7HP4Vc.js")),
      TnIconViewTable: n(() => import("./TnIconview-table-L9GJguJ6.js")),
      TnIconVipps: n(() => import("./TnIconvipps-BQj8INt1.js")),
      TnIconVippsApp: n(() => import("./TnIconvipps-app-IVWJp3d7.js")),
      TnIconVippsAppNegative: n(() => import("./TnIconvipps-app-negative-D9QtoNn5.js")),
      TnIconVoicemail: n(() => import("./TnIconvoicemail-Cu-HmoyB.js")),
      TnIconWarningCircleFilled: n(() => import("./TnIconwarning-circle-filled-zuDvjpr3.js")),
      TnIconWarningCircleOutline: n(() => import("./TnIconwarning-circle-outline-DN-B-GHq.js")),
      TnIconWatch: n(() => import("./TnIconwatch-BOP6-608.js")),
      TnIconWeeklyArchive: n(() => import("./TnIconweekly-archive-c_3qO7b2.js")),
      TnIconWiFi: n(() => import("./TnIconwi-fi-CC6aqU-Y.js")),
      TnIconWiFiHome: n(() => import("./TnIconwi-fi-home-CEsnCBpM.js")),
      TnIconWizard: n(() => import("./TnIconwizard-Cc9hzmNb.js")),
      TnIconX: n(() => import("./TnIconx-DJWpgeV5.js")),
      TnIconYouTube: n(() => import("./TnIconyou-tube-BzRRoqUd.js")),
      TnIconZoomIn: n(() => import("./TnIconzoom-in-D2qZOQbs.js")),
      TnIconZoomOut: n(() => import("./TnIconzoom-out-oWJyhguy.js"))
    }, m = p(() => {
      if (!o.name) return null;
      const i = Object.keys(r).find((c) => c.toLowerCase() === `tnicon${o.name.toLowerCase().replace(/-/g, "")}`);
      return i ? r[i] : null;
    });
    return (i, c) => (l(), I(a(m.value), {
      height: t.value,
      width: t.value,
      fill: i.color
    }, null, 8, ["height", "width", "fill"]));
  }
});
export {
  u as TnIcon
};
